// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"31d967b6fb66de33","8537":"7e5c6ae61ed9bc74"}[chunkId] + ".js";
};